import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ILogChangeBreakdownItem } from './log-change-breakdown.model';

@Component({
  selector: 'app-log-change-breakdown',
  templateUrl: './log-change-breakdown.component.html',
  styleUrls: ['./log-change-breakdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LogChangeBreakdownComponent {
  @Input() title = '';
  @Input() titleKey = '';
  @Input() titleParams?: Record<string, string | number>;
  @Input() actionKey = '';
  @Input() changes: ILogChangeBreakdownItem[] = [];

  isOpen = false;

  onToggle(event: Event): void {
    this.isOpen = (event.currentTarget as HTMLDetailsElement).open;
  }
}
